<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
    @scroll="handleScroll"
  >
  <BackgroundImage />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <!-- ViewLicense -->
    <transition name="popup">
      <PCServiceLicenseCancelInputInvalidUser
        v-if="cancellation.visiblePopup === 'userInput'"
        @closeServiceLicenseCancelInputInvalidUser="action.closeUserInput"
        @openViewConfirm="action.submitUserInput"
      />
    </transition>

    <!-- View License Confirm-->
    <transition name="popup">
      <PCServiceLicenseCancelInputConfirm
        v-if="cancellation.visiblePopup === 'confirm'"
        @closeViewConfirm="action.closeConfirm"
        @openViewComplete="action.submitConfirm"
      />
    </transition>

    <!-- View License Complete-->
    <transition name="popup">
      <PCServiceLicenseCancelInputComplete
        v-if="cancellation.visiblePopup === 'complete'"
        @closeViewComplete="action.closeComplete"
      />
    </transition>

    <div id="wrapper">
      <PCContractHeader />

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- Cancel Input Popup -->
      <transition name="popup">
        <PCServiceLicenseCancelCancel
          v-if="state.visibleCancelInput"
          @closeServiceLicenseCancel="state.visibleCancelInput = false"
        />
      </transition>

      <!-- content:start -->
      <div id="content"
        ref="areaScrollable"
        :style="{'height' : scrollableHeight + 'px'}"
        >
        <div class="service" id="scroll-target"
          @scroll="handleScroll"
          >
          <div class="service-head">
            <h1 class="hdg02">ライセンスの解約（次年）</h1>
          </div>
          <form v-if="state.loaded" class="service-container">
            <div class="service-content">
              <p v-if="signedPackageProduct.length > 0" class="txt">次年の契約内容を変更できます。<br>パッケージ、商品、または、ライセンス数を指定して解約手続きをしてください。<br>解約は次回自動継続時に適用される解約予約となります。</p>
              <p v-else class="txt">ご契約中のサービスはありません。</p>
              <template v-if="signedPackageProduct.length > 0">
                <h2 class="hdg03">契約中パッケージのライセンス解約</h2>
                <ul class="service-content-list">
                  <li class="service-content-list-item">
                    <table class="license-content-table border">
                      <colgroup>
                        <col style="width:20%;">
                        <col sytle="width:40%;">
                        <col sytle="width:20%;">
                        <col sytle="width:15%;">
                        <col sytle="width:5%;">
                      </colgroup>
                      <thead>
                        <tr>
                          <th>パッケージ</th>
                          <th>商品</th>
                          <th></th>
                          <th class="ta-center">ライセンス数を指定</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(product, index) in signedPackageProduct" :key="'signedpack_' + index">
                          <th v-if="index === 0 || product.packIndex !== product.prevPackIndex" :rowspan="product.count">
                            <div class="license-content-table-hdg">{{product.package_name}}</div>
                          </th>
                          <td :class="product.classification !== 2 && 'pl20'">
                            <div class="license-content-table-title">{{product.name}}</div>
                            <div class="license-content-table-sup mt12">{{visible.note(index)}}</div>
                          </td>
                          <td>
                            <div class="license-content-table-link">
                              <div v-if="visible.cancel(index) && !visible.parentCancel(index)" @click="action.cancel(index)" role="button">解約予約の取り消し</div>
                              <span v-else-if="visible.allCancel(index)" @click="action.allCancel(index)" role="button">ライセンスをすべて解約</span>
                            </div>
                          </td>
                          <td>
                            <div v-if="visible.cancel(index)" class="license-content-table-sup ta-center">解約予約済</div>
                            <div v-else-if="product.license_number <= cancellation.lists[index].cancellation" class="ta-center">解約</div>
                            <div v-else-if="visible.select(index) && product.select.length > 1" class="license-content-table-select">
                              <SelectBox
                                :selected="cancellation.lists[index].cancellation"
                                :lists="product.select"
                                @change="action.selectBoxOnChange($event, index)"
                                />
                            </div>
                            <div v-else-if="product.select.length <= 1" class="license-content-table-sup ta-center">-</div>
                          </td>
                          <td>
                            <div :style="{visibility: visible.reset(index) ? 'visible' : 'hidden'}" @click="action.reset(index)" class="license-content-table-reset" role="button">
                              <div class="license-content-table-reset-tip">リセット</div>
                              <FontawesomeIcon :icon="['far','eraser']" size="lg" class="icn"/>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </li>
                </ul>
              </template>
              <div class="service-submit">
                <div :class="['button', 'service-submit-button', cancellationList.length <= 0 && 'is-inactive']">
                  <span class="btn ga-admin-license-cancel-confirm" @click="action.submit" role="button">確認</span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { ServiceLicenseCancelInput } from '@/logic/contract/ServiceLicenseCancelInput'

import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCContractHeader from '@/components/pc/partial/contract/ContractHeader.vue'
import PCServiceLicenseCancelCancel from '@/components/pc/popup/PCServiceLicenseCancelCancel.vue'
import PCServiceLicenseCancelInputInvalidUser from '@/components/pc/popup/PCServiceLicenseCancelInputInvalidUser.vue'
import PCServiceLicenseCancelInputConfirm from '@/components/pc/popup/PCServiceLicenseCancelInputConfirm.vue'
import PCServiceLicenseCancelInputComplete from '@/components/pc/popup/PCServiceLicenseCancelInputComplete.vue'
import SelectBox from '@/components/pc/partial/SelectBox.vue'

export default defineComponent({
  components: {
    PCMenu,
    PCServiceLicenseCancelCancel,
    PCServiceLicenseCancelInputInvalidUser,
    PCServiceLicenseCancelInputConfirm,
    PCServiceLicenseCancelInputComplete,
    PCContractHeader,
    SelectBox
  },
  setup (props, context) {
    return { ...ServiceLicenseCancelInput(props, context) }
  }
})
</script>

<style lang="scss" scoped>
#content {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 60px;
  overflow-y: auto;
}
.service {
  width: 100%;
  overflow: auto;
  &-container {
    border-top: 1px solid $color-line;
    padding: 40px 0 150px;
    .button .btn[type="submit"] {
      width: 230px;
      margin: 32px auto 0;
    }
  }
  &-head {
    padding: 35px 40px;
    [class^="hdg"] {
      margin-bottom: 0;
    }
  }
  &-content {
    max-width: 1105px;
    padding: 0 40px;
    margin: 0 auto;
    .hdg03{
      margin: 72px 0 29px;
    }
    &-list {
      list-style: none;
      &-item {
        border-top: 1px solid $color-line;
        padding: 32px 0;
      }
    }
    &-table {
      width: 100%;
      border-collapse: collapse;
      .border-none {
        border: 0!important;
      }
      &.border-bottom {
        border-bottom: 1px solid $color-line;
      }
      thead {
        th {
          color: $color-sup;
          font-size: 1.6rem;
          font-weight: normal;
          padding: 16px 10px;
        }
      }
      tbody {
        th {
          vertical-align: baseline;
        }
        th,td {
          padding: 24px 10px;
          border-top: 1px solid $color-line;
        }
      }
      &-hdg {
        display: block;
        color: $color-hdg;
        font-size: 1.6rem;
        font-weight: bold;
        &.is-inactive {
          color: $color-inactive;
        }
      }
      &-sup {
        color: $color-sup;
        font-size: 1.4rem;
      }
      &-btnarea {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        .license-content-table-link {
          margin-left: 20px;
        }
      }
      &-btn {
        width: 160px;
        .formparts.select .select-label,
        .button .btn {
          height: 32px;
        }
      }
      &-link {
        font-size: 1.6rem;
        color: $color-link;
        float: right;
        margin-left: -20px;
      }
      // &-list {
      //   li {
      //     padding-left: 10px;
      //   }
      //   .checkbox {
      //     padding: 12px 0;
      //   }
      //   .textarea {
      //     textarea {
      //       width: 100%;
      //     }
      //   }
      //   &-parts {
      //     display: flex;
      //     align-items: center;
      //     padding: 12px 0 12px 30px;
      //     .txt,
      //     .select {
      //       display: inline-block;
      //       margin-right: 12px;
      //       margin-bottom: 0;
      //     }
      //     .select-label {
      //       height: 32px;
      //     }
      //   }
      // }
    }
  }
  &-submit {
    width: 230px;
    margin: 0 auto;
  }
}
</style>
